import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { getTranslate } from "react-localize-redux";
import { fileActions, settingActions } from "../../../../redux/actions";
import { getFileColumns } from ".";

function mapStateToProps(state) {
  const { user, subUser, isSubUser } = state.authentication;
  return {
    translate: getTranslate(state.locale),
    hiddenColumns: state.files.hiddenColumns,
    columnToShowMenu: state.files.columnToShowMenu,
    user,
    subUser,
    isSubUser
  };
}
class ColumnToggleMenu extends Component {
  toggleMenu = column => {
    const { dispatch } = this.props;
    dispatch(fileActions.toggleShowColumnMenu(column));
  };
  handleChange = (e, column) => {
    const { user, subUser, isSubUser, dispatch, hiddenColumns } = this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    e.stopPropagation();
    e.preventDefault();
    dispatch(fileActions.toggleHiddenColumn(column));
    let _hiddenColumns = (hiddenColumns || []).slice(0);
    var index = _hiddenColumns.indexOf(column);
    if (index >= 0) {
      _hiddenColumns.splice(index, 1);
    } else {
      _hiddenColumns.push(column);
    }
    let gridsSettings = (currentUser.gridsSettings || []).slice(0);
    gridsSettings = gridsSettings.filter(item => item.gridId !== "files");
    gridsSettings.push({
      gridId: "files",
      visibleColumns: _hiddenColumns
    });
    dispatch(
      settingActions.changeUserGridsSettings(gridsSettings, currentUser)
    );
  };

  render() {
    const {
      hiddenColumns,
      columnToShowMenu,
      currentColumn,
      isSubUser,
      translate
    } = this.props;
    const allColumns = getFileColumns(translate, isSubUser);
    return (
      <Dropdown
        className="trigger"
        isOpen={columnToShowMenu === currentColumn}
        toggle={() => this.toggleMenu(currentColumn)}
      >
        <DropdownToggle
          className="btn btn-default btn-circle"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <i className="fa fa-angle-down"></i>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem header>{translate("Columns to display...")}</DropdownItem>
          {allColumns.map((item, index) => (
            <DropdownItem
              header
              key={index}
              className="checkbox-items"
              size="sm"
              data-action="multi-select-action"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <FormGroup check>
                <Label check onClick={e => this.handleChange(e, item.key)}>
                  <Input
                    type="checkbox"
                    readOnly
                    checked={!(hiddenColumns || []).includes(item.key)}
                  />{" "}
                  {item.text}
                </Label>
              </FormGroup>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default connect(mapStateToProps)(ColumnToggleMenu);
